/**
 * ============================================================
 * DIBAI 18K — Sección Testimonios
 * assets/testimonios-dibai.js  v1.0.0
 *
 * - Muestra `per_page` tarjetas inicialmente
 * - Botón "Ver más" revela el siguiente lote con animación
 * - Botón cambia a "Ver menos" cuando todas están visibles
 * - Clic en tarjeta navega a URL del producto (si existe)
 * - Soporte Shopify Theme Editor
 * ============================================================
 */

(function () {
  'use strict';

  function initSection(root) {
    if (!root) return;

    const grid      = root.querySelector('[data-tdb-grid]');
    const moreBtn   = root.querySelector('[data-tdb-more]');
    const footer    = root.querySelector('[data-tdb-footer]');
    const moreLabel = root.querySelector('[data-tdb-more-label]');

    if (!grid) return;

    // Leer configuración
    const perPage     = parseInt(grid.dataset.perPage, 10) || 6;
    const cards       = Array.from(grid.querySelectorAll('.tdb-card'));
    const totalCards  = cards.length;

    // Leer etiquetas del botón desde data-attributes o atributos del section
    const section   = root.querySelector('.tdb-section');
    const labelMore = getLabelMore(root);
    const labelLess = getLabelLess(root);

    let visibleCount  = 0;
    let allVisible    = false;

    // ── Ocultar todas primero, luego mostrar el primer lote ──
    cards.forEach(card => {
      card.setAttribute('data-tdb-hidden', '');
    });

    showBatch();

    // ── Botón ──
    if (moreBtn) {
      moreBtn.addEventListener('click', handleMoreClick);
    }

    // ── Navegación en tarjetas clicables ──
    cards.forEach(card => {
      const url = card.dataset.tdbUrl;
      if (!url) return;

      card.addEventListener('click', () => {
        window.location.href = url;
      });

      // Teclado: Enter y Space
      card.addEventListener('keydown', e => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          window.location.href = url;
        }
      });
    });

    // ──────────────────────────────────────
    function showBatch() {
      const nextBatch = cards.slice(visibleCount, visibleCount + perPage);
      let delay = 0;

      nextBatch.forEach(card => {
        card.removeAttribute('data-tdb-hidden');

        // Animación escalonada
        card.classList.remove('tdb-card--reveal');
        void card.offsetWidth; // reflow para reiniciar animación
        card.style.animationDelay = `${delay}ms`;
        card.classList.add('tdb-card--reveal');
        delay += 50;
      });

      visibleCount += nextBatch.length;

      // Actualizar estado
      allVisible = visibleCount >= totalCards;
      updateButton();
    }

    function hideBatch() {
      // Ocultar todo excepto el primer lote
      cards.slice(perPage).forEach(card => {
        card.setAttribute('data-tdb-hidden', '');
        card.classList.remove('tdb-card--reveal');
        card.style.animationDelay = '';
      });

      visibleCount = perPage;
      allVisible   = false;

      updateButton();

      // Scroll suave de regreso al grid
      grid.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }

    function handleMoreClick() {
      if (allVisible) {
        hideBatch();
      } else {
        showBatch();
      }
    }

    function updateButton() {
      if (!moreBtn || !footer) return;

      if (totalCards <= perPage) {
        // No hay más que mostrar nunca
        footer.setAttribute('data-tdb-hidden', '');
        return;
      }

      footer.removeAttribute('data-tdb-hidden');

      if (allVisible) {
        // Cambiar a "Ver menos"
        if (moreLabel) moreLabel.textContent = labelLess;
        moreBtn.setAttribute('aria-label', labelLess);
        moreBtn.classList.add('is-expanded');
      } else {
        // Cambiar a "Ver más"
        if (moreLabel) moreLabel.textContent = labelMore;
        moreBtn.setAttribute('aria-label', labelMore);
        moreBtn.classList.remove('is-expanded');
      }
    }

    // Leer labels del DOM (generados por Liquid)
    function getLabelMore(root) {
      const btn = root.querySelector('[data-tdb-more]');
      if (!btn) return 'Mostrar más reseñas';
      // El label está en el span inicial; guardarlo antes de cambios
      const label = root.querySelector('[data-tdb-more-label]');
      return label ? label.textContent.trim() : 'Mostrar más reseñas';
    }

    function getLabelLess(root) {
      const sec = root.querySelector('.tdb-section');
      return sec?.dataset.tdbLabelLess || 'Ver menos';
    }
  }

  // ─────────────────────────────────────────
  // INICIALIZACIÓN
  // ─────────────────────────────────────────
  function initAll() {
    document.querySelectorAll('.testimonios-dibai-wrapper').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Shopify Theme Editor
  document.addEventListener('shopify:section:load', e => {
    const root = e.target.closest('.testimonios-dibai-wrapper')
      || e.target.querySelector('.testimonios-dibai-wrapper');
    if (root) initSection(root);
  });

  document.addEventListener('shopify:block:select', e => {
    // Al seleccionar un bloque en el editor, asegurarse que sea visible
    const card = e.target.closest('.tdb-card');
    if (card && card.hasAttribute('data-tdb-hidden')) {
      card.removeAttribute('data-tdb-hidden');
    }
  });

})();
